export const STATUS_PRESETS = {
  warning: ["warning"],
  critical: ["critical"],
  warning_or_critical: ["warning", "critical"],
  healthy: ["healthy"]
};
export const HEALTH_ALERT_TYPE = "health-alert-v1";
